module.exports = __webpack_public_path__ + "img/icon-cont-2.43979087.png";